// The bonus-dataset boolean field that, when added to the fact table, becomes a
// per-week eligibility (qualifier) override dropdown in override mode.
export const ELIGIBILITY_FIELD = 'qualifiesForBonus';

/**
 * The reward a fact-table pay/points column maps to, or undefined for a non-reward
 * column. Used to decide which column becomes a per-week override dropdown.
 *
 * Two ways a column maps to a reward:
 *   1. Exact reward value field — e.g. `safetyPoints` is the `safety` reward's
 *      `rewardValueField`.
 *   2. Suffix strip — a `*Pay` / `*Points` column maps to the reward of the same
 *      name with the suffix removed (e.g. `safetyBonusPay` → `safetyBonus`). This
 *      covers the cash `additional_monetary_rewards` twins, which are NOT listed in
 *      the program's `rewardFields`. The resolved name is validated downstream
 *      against the record's actual override options, so a column that doesn't map
 *      to a real overridable reward simply stays a plain figure.
 */
const overridableRewardName = ({
  field,
  program,
}: {
  field: string;
  program: BonusTypes.BonusProgram | undefined;
}): string | undefined => {
  if (!program) {
    return undefined;
  }
  const byValueField = program.rewardFields.find(
    (rf) => rf.rewardValueField === field,
  )?.name;
  if (byValueField) {
    return byValueField;
  }
  const stripped = field.replace(/(Pay|Points)$/, '');
  return stripped && stripped !== field ? stripped : undefined;
};

export default overridableRewardName;
